// extracted by mini-css-extract-plugin
export default {"cls1":"QjPbwZ5YAiqVKvBmW6XG","cls2":"PDWTRX7yVNFkBgkKBv6Y QjPbwZ5YAiqVKvBmW6XG"};